<template>
  <div :class="['section', $style.uploadSuccessContainer]">
    <div class="content">
      <p :class="['has-text-weight-bold', $style.uploadHeader]">
        {{ fileName }} has been uploaded for processing
      </p>
      <div :class="[$style.uploadDetails]">
        Your file is being processed in background, you may close this dialog.
        You will be notified once it has been uploaded.
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class UploadTimeout extends Vue {
  @Prop(String) private fileName!: string;
}
</script>

<style lang="scss" module>
@import './style.scss';
</style>
